export const ACCOUNT_STATE_TAB = 'ACCOUNT_STATE_TAB';